import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColumnHideManService {
  constructor() {}

  public initHides: string[];

  public initColHide(hides, type: string) {
    this.initHides = hides;
    var colInfo = JSON.parse(localStorage.getItem('ColInfo'));
    if (colInfo && colInfo[type]) return this.initHides.concat(colInfo[type].split(',')) ?? [];
    return this.initHides ?? [];
  }
  public setColHide(columns, type: string) {
    if (!columns) return;
    var cols = (columns.toArray ? columns.toArray() : [])
      .filter(x => x.isHidden)
      .map(x => x.field.toLowerCase())
      .join(',');
    var colInfo = localStorage.getItem('ColInfo') ? JSON.parse(localStorage.getItem('ColInfo')) : Object.create(null);
    colInfo[type] = cols;
    localStorage.setItem('ColInfo', JSON.stringify(colInfo));
  }
  public removeColHide(type: string) {
    var colInfo = localStorage.getItem('ColInfo') ? JSON.parse(localStorage.getItem('ColInfo')) : Object.create(null);
    colInfo[type] = '';
    localStorage.setItem('ColInfo', JSON.stringify(colInfo));
    return this.initHides;
  }
  public columnHiddenChange(columns) {
    //Bekomme immer ein Fehler von wegen ExpressionChangeBeforeX was zu ner Endlosschleife führt, bekomme das gerade nicht normal gelöst
    var x: string[];

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(
          columns
            .toArray()
            .filter(x => x.isHidden)
            .map(x => x.field.toLowerCase())
        );
      }, 200);
    });
  }
}
